/**
 * Build public job detail / apply paths.
 * Company-branded jobs use /{companySlug}/startup-jobs/:jobId
 * (e.g. NodeMeta → /nodemeta/startup-jobs/...).
 */

export const companySlugFromName = (name) =>
  String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');

export const getJobDetailPath = (jobOrId, companyName = '') => {
  const id =
    typeof jobOrId === 'string' || typeof jobOrId === 'number'
      ? String(jobOrId)
      : String(jobOrId?.id || '');
  const name =
    typeof jobOrId === 'object' && jobOrId
      ? jobOrId.companyName || companyName
      : companyName;
  const slug = companySlugFromName(name);
  const encoded = encodeURIComponent(id);
  if (slug) return `/${slug}/startup-jobs/${encoded}`;
  return `/startup-jobs/${encoded}`;
};

export const getJobApplyPath = (jobOrId, companyName = '') =>
  `${getJobDetailPath(jobOrId, companyName)}/apply`;
